import { useFlags } from 'launchdarkly-react-client-sdk';
import { useCallback } from 'react';

const useDebug = () => {
  const flags = useFlags();
  return useCallback((...args: unknown[]) => (flags.debug ? console.log(...args) : null), [flags.debug]);
};

export default useDebug;
